module.exports = __webpack_public_path__ + "img/06-full.6379a8ad.jpg";